import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { instance } from 'api/axios.instance';

import { Section, Box, Text, Table, Flex, Button, Dialog } from '@radix-ui/themes';
import PageTitle from 'components/layout/PageTitle';

import { formatCommas } from 'util/validation';

export default function RealSurveyDetail() {
  const { year, region } = useParams();
  const navigate = useNavigate();

  const tempData = {
    title: '실태조사 제목 영역',
    year: '연도',
    region: '지역명',
    totalCompany: 0, // 기업 수(합계)
    itCompany: 0, // 기업 수(IT제조)
    serviceCompany: 0, // 기업 수(IT서비스)
    swCompany: 0, // 기업 수(SW)
    totalEmployee: 0, // 종사자 수(합계)
    itEmployee: 0, // 종사자 수(IT제조)
    serviceEmployee: 0, // 종사자 수(IT서비스)
    swEmployee: 0, // 종사자 수(SW)
    totalSale: 0, // 매출액(합계) (단위: 백만원)
    itSale: 0, // 매출액(IT제조)
    serviceSale: 0, // 매출액(IT서비스)
    swSale: 0 // 매출액(SW)
  };

  // state
  const [realSurveyData, setRealSurveyData] = useState(tempData);

  // 실태조사 상세 (지역/년도 필터) API
  const fetchRealSurveyDetail = useCallback(async () => {
    const response = await instance(`/statistic/${year}/${region}`, {
      method: 'GET'
    });
    setRealSurveyData(response.data.data);
  }, [year]);

  // mount 시 호출
  useEffect(() => {
    fetchRealSurveyDetail();
  }, [fetchRealSurveyDetail]);

  return (
    <Section>
      <PageTitle title="지역 디지털 산업 생태계 실태조사 상세" />
      <Box className="box box-white">
        <Box mb="var(--space-10)">
          <Table.Root className="table-write">
            {/* <Table.Body>
                            <Table.Row align="center">
                                <Table.ColumnHeaderCell width="100px">
                                    <Text>제목</Text>
                                </Table.ColumnHeaderCell>
                                <Table.Cell width="auto">
                                    <Text as="p" color="gray">
                                        {realSurveyData?.title}
                                    </Text>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body> */}
            <Table.Body>
              <Table.Row align="center">
                <Table.ColumnHeaderCell width="180px">
                  <Text>데이터 년도</Text>
                </Table.ColumnHeaderCell>
                <Table.Cell width="auto">
                  <Text as="p" color="gray">
                    {realSurveyData?.year}
                  </Text>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
            <Table.Body>
              <Table.Row align="center">
                <Table.ColumnHeaderCell width="180px">
                  <Text>지역</Text>
                </Table.ColumnHeaderCell>
                <Table.Cell width="auto">
                  <Text as="p" color="gray">
                    {realSurveyData?.region}
                  </Text>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table.Root>
        </Box>

        <Box>
          <Text as="p" className="sub-title1">
            주요 데이터
          </Text>
          <Box mt="var(--space-1)">
            <Table.Root className="table-write">
              {/* 기업 수 */}
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>기업 수(합계)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.totalCompany) + '개'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>기업 수(IT제조)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.itCompany) + '개'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>기업 수(IT서비스)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.serviceCompany) + '개'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>기업 수(SW)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.swCompany) + '개'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              {/* 종사자 수 */}
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>종사자 수(합계)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.totalEmployee) + '명'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>종사자 수(IT제조)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.itEmployee) + '명'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>종사자 수(IT서비스)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.serviceEmployee) + '명'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>종사자 수(SW)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.swEmployee) + '명'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              {/* 매출액 */}
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>매출액(합계) (단위: 백만원)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.totalSale) + '원'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>매출액(IT제조)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.itSale) + '원'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>매출액(IT서비스)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.serviceSale) + '원'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Body>
                <Table.Row align="center">
                  <Table.ColumnHeaderCell width="180px">
                    <Text>매출액(SW)</Text>
                  </Table.ColumnHeaderCell>
                  <Table.Cell width="auto">
                    <Text as="p" color="gray">
                      {formatCommas(realSurveyData?.swSale) + '원'}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
          </Box>
        </Box>
      </Box>

      {/* 페이지 버튼 */}
      <Box>
        <Flex justify="between">
          <Button
            variant="outline"
            onClick={() => {
              navigate('/realSurvey');
            }}
          >
            목록
          </Button>
          {/* <Flex justify="end" gap="2">
                        <Dialog.Root>
                            <Dialog.Trigger>
                                <Button onClick={() => navigate(`/realSurvey/write/${id}`)}>수정</Button>
                            </Dialog.Trigger>
                        </Dialog.Root>
                        <Dialog.Root>
                            <Dialog.Trigger>
                                <Button>삭제</Button>
                            </Dialog.Trigger>
                            <ConfirmDialog title="컨텐츠 삭제" description="해당 내용을 제거 하시겠습니까?" />
                        </Dialog.Root>
                    </Flex> */}
        </Flex>
      </Box>
    </Section>
  );
}
